// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://balloon-tracker-api.onrender.com';

export default {
  API_BASE_URL,
  // Add other configuration options here as needed
}; 